import { useEffect, useState } from "react";
import { Layout } from "@/components/Layout";
import { api } from "@/lib/api";
import { GraduationCap, Clock, BookOpen, ChevronRight } from "lucide-react";

export default function BeautyCollege() {
  const [courses, setCourses] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => { api.get("/courses").then((r) => setCourses(r.data)).catch(() => {}); }, []);

  return (
    <Layout>
      <section className="relative py-20 px-6 md:px-12 lg:px-20">
        <div className="max-w-7xl mx-auto">
          <span className="label-gold">Module 03 · Academy</span>
          <h1 className="text-5xl md:text-7xl font-black uppercase tracking-tighter text-white mt-3 mb-3">
            The Beauty <span className="gold-shimmer">War College</span>.
          </h1>
          <p className="text-white/60 max-w-2xl">
            Three EIGOO Standard curricula. Pre-loaded. Pre-tested. Ready to enroll students under the Admiral's banner.
          </p>

          <div className="grid lg:grid-cols-3 gap-6 mt-14">
            {courses.map((c) => (
              <article key={c.id} className="group relative border border-[#C9A227]/20 hover:border-[#C9A227]/70 transition-all overflow-hidden">
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img src={c.cover_image} alt={c.title} className="w-full h-full object-cover group-hover:scale-[1.06] transition-transform duration-700"/>
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent"/>
                  <span className="absolute top-4 left-4 text-[10px] tracking-[0.3em] uppercase text-[#C9A227] font-bold border border-[#C9A227]/50 px-2 py-1 bg-black/50 backdrop-blur">
                    {c.subtitle}
                  </span>
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 text-[10px] tracking-[0.25em] uppercase text-white/40 mb-3">
                    <span className="flex items-center gap-1"><Clock size={11}/> {c.duration_weeks}w</span>
                    <span className="flex items-center gap-1"><BookOpen size={11}/> {c.lesson_count} lessons</span>
                    <span className="text-[#C9A227]">{c.level}</span>
                  </div>
                  <h3 className="text-white text-xl font-black uppercase tracking-tight leading-tight">{c.title}</h3>
                  <p className="text-white/55 text-xs mt-3 leading-relaxed">{c.tagline}</p>
                  <div className="flex items-center justify-between mt-6">
                    <span className="text-2xl font-black gold-shimmer">${c.price.toFixed(0)}</span>
                    <button onClick={() => setActive(c)} className="btn-outline-gold text-[10px]" data-testid={`course-syllabus-${c.id}`}>
                      Syllabus <ChevronRight size={12} className="inline -mt-0.5"/>
                    </button>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Syllabus modal */}
      {active && (
        <div className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-md flex items-center justify-center p-4" onClick={() => setActive(null)}>
          <div className="glass border border-[#C9A227]/40 max-w-2xl w-full p-8" onClick={(e) => e.stopPropagation()}>
            <span className="label-gold">{active.subtitle}</span>
            <h3 className="text-white text-3xl font-black uppercase tracking-tighter mt-2">{active.title}</h3>
            <p className="text-white/60 mt-3">{active.tagline}</p>
            <div className="hairline my-6"/>
            <ol className="space-y-3">
              {active.modules?.map((m, i) => (
                <li key={i} className="flex gap-4">
                  <span className="text-[#C9A227] font-black tabular-nums">{String(i + 1).padStart(2, "0")}</span>
                  <span className="text-white/80 text-sm">{m}</span>
                </li>
              ))}
            </ol>
            <button onClick={() => setActive(null)} className="btn-gold text-xs mt-8">Close</button>
          </div>
        </div>
      )}
    </Layout>
  );
}
